<div class="preloader">
  @if (!frameStatus && !widgetStatus) {
    <embed src="assets/images/svg/anime-logo/gif_animated_logo-min.gif" />
  }
  @if (frameStatus || widgetStatus) {
    <embed src="assets/images/svg/anime-logo/widget-loader.svg" />
  }
</div>
